module.exports = __webpack_public_path__ + "static/media/residential.f679e79a.svg";